import { render, staticRenderFns } from "./DemandaContratadaForaPontaField.vue?vue&type=template&id=006138d8&scoped=true&"
import script from "./DemandaContratadaForaPontaField.vue?vue&type=script&lang=js&"
export * from "./DemandaContratadaForaPontaField.vue?vue&type=script&lang=js&"
import style0 from "./DemandaContratadaForaPontaField.vue?vue&type=style&index=0&id=006138d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006138d8",
  null
  
)

export default component.exports